import swal from "sweetalert2";

export async function alertDeactivatedSelection(name) {
	try {
		await swal.fire({
			title: "Deactivated Value",
			html: `Uh-oh.  It looks like ${name || "the item you selected"} is deactivated.  Please select a different option if available.`,
			showCloseButton: true,
			type: "warning"
		});
	}catch(err) {
		return false;
	}
}